<template>
    <div>
        <div class="view-container">
            <div
                ref="view"
                class="view"
            ></div>
        </div>
    </div>
</template>

<script>
import EditorRender from '@it/parker/es/render';

import BulletListRender from '@it/parker/es/citadel-pc/extensions/bullet-list-extension/render';
import OrderedListRender from '@it/parker/es/citadel-pc/extensions/ordered-list-extension/render';
import TaskListRender from '@it/parker/es/citadel-pc/extensions/task-list-extension/render';
import TableRender from '@it/parker/es/citadel-pc/extensions/table-extension/render';
import NoteRender from '@it/parker/es/citadel-pc/extensions/note-extension/render';
import CollapseRender from '@it/parker/es/citadel-pc/extensions/collapse-extension/render';
import BlockquoteRender from '@it/parker/es/citadel-pc/extensions/blockquote-extension/render';
import ImageRender from '@it/parker/es/citadel-pc/extensions/image-extension/render';
import LinkRender from '@it/parker/es/citadel-pc/extensions/link-extension/render';
import StatusRender from '@it/parker/es/citadel-pc/extensions/status-extension/render';
import TimeRender from '@it/parker/es/citadel-pc/extensions/time-extension/render';
import LatexRender from '@it/parker/es/citadel-pc/extensions/latex-inline-extension/render';
import AttachmentRender from '@it/parker/es/citadel-pc/extensions/attachment-extension/render';
import VideoRender from '@it/parker/es/citadel-pc/extensions/video-extension/render';
import CatalogRender from '@it/parker/es/citadel-pc/extensions/catalog-extension/render';

export default {
    name: 'PcPreview',
    props: {
        text: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            renderIns: null,
        };
    },
    watch: {
        text(val) {
            this.text = val;
            this.renderIns.render(this.text);
        },
    },
    mounted() {
        this.renderIns = new EditorRender(this.$refs.view, {
            renders: [
                new BulletListRender(),
                new OrderedListRender(),
                new TaskListRender(),
                new TableRender(),
                new NoteRender(),
                new CollapseRender(),
                new BlockquoteRender(),
                new ImageRender(),
                new LinkRender(),
                new StatusRender(),
                new TimeRender(),
                new LatexRender(),
                new AttachmentRender(),
                new VideoRender(),
                new CatalogRender(),
            ],
            lazyload: true,
        });
        this.renderIns.render(this.text);
    },
};
</script>

<style scoped>
.view-container {
  margin: 0px auto;
  white-space: break-spaces;
}
.view {
  padding: 4px 16px;
  height: 100%;
  overflow-y: auto;
}
</style>
